import { render, staticRenderFns } from "./EducationalJoiningApplicationChangeApproveAccepted.vue?vue&type=template&id=65c4208a&"
import script from "./EducationalJoiningApplicationChangeApproveAccepted.vue?vue&type=script&lang=js&"
export * from "./EducationalJoiningApplicationChangeApproveAccepted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports